import { useTranslation } from "@impero-com/common/utils/i18n";
import { InformationModal } from "@impero-com/ui";

import { Footer } from "components/modals/Footer";

interface CancelConfirmationDialogProps {
    open: boolean;
    onConfirm: () => void;
    onAbort: () => void;
}

export function CancelConfirmationDialog({
    open,
    onConfirm,
    onAbort,
}: CancelConfirmationDialogProps) {
    const { t } = useTranslation();
    return (
        <InformationModal
            open={open}
            onClose={onAbort}
            type="error"
            icon="unsavedChanges"
            title={t("Dialog_DiscardChanges_Title")}
            footer={
                <Footer
                    onClose={onAbort}
                    onConfirm={onConfirm}
                    confirmLabel={t("Discard")}
                    cancelLabel={t("KeepEditing")}
                    destructive
                />
            }
        >
            {t("TagsList_CreateCategoryDrawer_CancelConfirmation_Text")}
        </InformationModal>
    );
}
